import React, { useState } from "react";
// import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
// import { pdfjs } from "react-pdf";
import { Document, Page, pdfjs } from "react-pdf";
import { LeftOutlined, RightOutlined, PlusOutlined, MinusOutlined } from "@ant-design/icons";
// import "react-pdf/dist/umd/Page/AnnotationLayer.css";
// import "react-pdf/dist/umd/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PDFViewer = ({ urlPDF }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [zoom, setZoom] = useState(1); // Thêm state zoom

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const changePage = (offset) => {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  };

  const previousPage = () => {
    changePage(-1);
  };

  const nextPage = () => {
    changePage(1);
  };

  const zoomIn = () => {
    if (zoom < 2) {
      // Giới hạn tỷ lệ phóng to là 200%
      setZoom((prevZoom) => prevZoom + 0.1); // Tăng tỉ lệ phóng to lên 10%
      // setPdfHeight((prevHeight) => prevHeight * 1.25); // Tăng chiều cao lên 25%
    }
  };

  const zoomOut = () => {
    if (zoom > 0.5) {
      // Giới hạn tỷ lệ thu nhỏ là 50%
      setZoom((prevZoom) => Math.max(prevZoom - 0.1, 0.1)); // Giảm tỉ lệ phóng to xuống 10% hoặc tối thiểu là 10%
      // setPdfHeight((prevHeight) => Math.max(prevHeight / 1.25, 100)); // Giảm chiều cao xuống 25% hoặc tối thiểu là 100px
    }
  };

  return (
    <div className="view-pdf-container">
      <div className="pdf-controls">
        <button type="button" disabled={pageNumber <= 1} onClick={previousPage} title="Kế trước">
          <LeftOutlined />
        </button>
        <span className="view-pdf-pagin">
          Trang {pageNumber} / {numPages}
        </span>
        <button
          type="button"
          disabled={pageNumber >= numPages}
          onClick={nextPage}
          title="Kế sau"
        >
          <RightOutlined />
        </button>
        <button type="button" onClick={zoomIn} style={{ cursor: "pointer"}} title="Phóng to">
          <PlusOutlined />
        </button>
        <button type="button" onClick={zoomOut} style={{ cursor: "pointer"}} title="Thu nhỏ">
          <MinusOutlined />
        </button>
      </div>
      <br></br>

      <div className="content-pdf">
        <Document
          file={urlPDF}
          onLoadSuccess={onDocumentLoadSuccess}
          error={<div>Không tải được tệp PDF / File không tồn tại.</div>}
          >
          <Page pageNumber={pageNumber} scale={zoom} className="pdf-page" />
        </Document>
      </div>
    </div>
  );
};
export default PDFViewer;

// import React, { Component } from "react";

// import { Viewer, Worker } from '@react-pdf-viewer/core';
// import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

// // Import styles
// import "@react-pdf-viewer/core/lib/styles/index.css";
// import "@react-pdf-viewer/default-layout/lib/styles/index.css";
// // import { pdfjs } from 'react-pdf';
// // pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

// // // pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
// // // Import pdfjs from pdfjs-dist
// import { GlobalWorkerOptions } from 'pdfjs-dist';

// GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.12.31/pdf.worker.min.js`;

// const PDFViewer = ({ urlPDF }) => {
//   // Create new plugin instance
//   const defaultLayoutPluginInstance = defaultLayoutPlugin();
//   // Cấu hình pdfjs để sử dụng worker từ pdfjs-dist

//   return (
//     <div>
//         {/* <div style={{ height: '750px' }}>
//             <Viewer
//                 fileUrl={urlPDF}
//                 plugins={[
//                     defaultLayoutPluginInstance,
//                 ]}
//             />
//         </div> */}

//       <Worker
//         workerUrl={`//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.12.31/pdf.worker.min.js`}
//       >
//         <Viewer
//           fileUrl={urlPDF}
//           plugins={[
//             // Register plugins
//             defaultLayoutPluginInstance,
//           ]}
//         />
//       </Worker>
//     </div>
//   );
// };

// export default PDFViewer;
